
var navbarlabel = document.querySelector('.navbar label');
if (navbarlabel != null){
    navbarlabel.addEventListener('click', () => {
        const menu_button_mobile = document.querySelector('.navbar label')
        const menu = document.querySelector('.navbar-nav')
        if (menu_button_mobile.classList.contains('menu_button_active')) {
            menu_button_mobile.classList.remove('menu_button_active');
            menu.classList.remove('show_menu');
            document.querySelector('body').classList.remove('scroll-hidden')
            document.querySelector('nav').style.backgroundColor = 'var(--color-black-default)'
        } else {
            menu_button_mobile.classList.add('menu_button_active');
            menu.classList.add('show_menu');
            document.querySelector('body').classList.add('scroll-hidden');
            document.querySelector('nav').style.backgroundColor = '#000'
        }
    })
}

document.querySelectorAll('.nav-item').forEach(el => {
    el.addEventListener('click', () => {
        const menu_button_mobile = document.querySelector('.navbar label')
        const menu = document.querySelector('.navbar-nav')
        if (menu_button_mobile.classList.contains('menu_button_active')) {
            menu_button_mobile.classList.remove('menu_button_active');
            menu.classList.remove('show_menu');
            document.querySelector('body').classList.remove('scroll-hidden')
        }
    })
})

document.querySelectorAll('.link').forEach(el => {
    el.addEventListener('click', () => {
        document.querySelector('body').classList.remove('scroll-hidden')
    })
})

